/*
 * Clamps a long product title to a couple of lines and reveals the rest behind
 * a more/less toggle. The toggle stays hidden unless the text actually
 * overflows, so short titles are left alone.
 */
class ExpandableTitle extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('[data-expandable-text]');
    this.toggle = this.querySelector('[data-expandable-toggle]');
    if (!this.text || !this.toggle) return;

    this.moreLabel = this.dataset.moreLabel || 'more';
    this.lessLabel = this.dataset.lessLabel || 'less';

    this.onToggle = this.onToggle.bind(this);
    this.sync = this.sync.bind(this);
    this.toggle.addEventListener('click', this.onToggle);

    // Fonts land after first paint and change how many lines the title takes.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.sync);
    }
    this.resizeObserver = new ResizeObserver(this.sync);
    this.resizeObserver.observe(this);
    this.sync();
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  sync() {
    // While expanded there is nothing to measure - the clamp is off.
    if (this.classList.contains('is-expanded')) return;
    const overflows = this.text.scrollHeight > this.text.clientHeight + 1;
    this.toggle.hidden = !overflows;
  }

  onToggle() {
    const expanded = this.classList.toggle('is-expanded');
    this.toggle.textContent = expanded ? this.lessLabel : this.moreLabel;
    this.toggle.setAttribute('aria-expanded', String(expanded));
    if (!expanded) this.sync();
  }
}

if (!customElements.get('expandable-title')) {
  customElements.define('expandable-title', ExpandableTitle);
}
